import React from 'react';
import {Container, NavDropdown, Nav, Navbar, Form, FormControl,Button, Row, Offcanvas } from 'react-bootstrap'
import $ from "jquery"
import { Link } from 'react-router-dom';
import "../stylesheets/style.css"
import "../js/main.js"
const Testimonials = () => {

return(
<div className='hmsixthbox'>

<div className='container'>

<div style={{paddingBottom:"30px"}} class="row">
               <div class="col-md-1 col-2">
                   {/* <h2  className="line hmsecondboxtitle"></h2> */}
                   <img style={{paddingTop:"30px" }} className="" src="images/line.png"/>

                   </div>
                   <div class="col-md-11 col-10">
                   <h2 className=" hmsecondboxtitle fordesktoponly">  Here are some words that<br/> keep us going.</h2>
                   <h2 className=" hmsecondboxtitle formobileonly">  Here are some words that keep us going.</h2>

                   </div>
               

           </div>
     
   <div class="row">
       <div class="col-md-6">
     

           <div class="row">
               <div class="col-md-1 col-2">
                   </div>
                   <div class="col-md-11 col-10">
                   <img src="/images/testimonials3.png"/>
                   </div>
                   </div>

                   <div class="row">
               <div class="col-md-1 col-2">
               <img className="hmsixthdescription" src="/images/colon.png"/>
                   </div>
                   <div class="col-md-10 col-10">
                  
                   <p className="hmsixthdescription">
            
                   The people I’ve met on this team give me peace of mind and I can’t wait to move into my home in September. This will be an astonishing surprise for my Wife and kids when they see our new home because I’m keeping it low key for now
. 
                
                </p>
                <p className="testimonialname formobileonly">Justin Amadi</p>

                   </div>
           </div>
       </div>




       <div class="col-md-6">
        
           <div class="row mobilerow">
               <div class="col-md-1 col-2">
                   </div>
                   <div class="col-md-11 col-10">
                   <img src="/images/testimonial2image.png"/>
                   </div>
                   </div>

                   <div class="row">
               <div class="col-md-1 col-2">
               <img className="hmsixthdescription" src="/images/colon.png"/>
                   </div>
                   <div class="col-md-10 col-10">
                  
                   <p className="hmsixthdescription">
            
                   I just made my second payment and I can’t wait to move in. Thank you for these flexible payment options, it’s a life saver 

                
                </p>
                <p className="testimonialname formobileonly">Adesewa Korede</p>

                   </div>
           </div>
       </div>

       <div style={{marginTop:"25px"}} class="col-md-6">
     

     <div class="row">
         <div class="col-md-1 col-2">
             </div>
             <div class="col-md-11 col-10">
             </div>
             </div>

             <div class="row">
         <div class="col-md-1 col-2">
             </div>
             <div class="col-md-10 col-10">
            
          
  
  <p className="testimonialname fordesktoponly">Justin Amadi</p>
             </div>
     </div>
 </div>




 <div style={{marginTop:"25px"}}  class="col-md-6">
  
     <div class="row mobilerow">
         <div class="col-md-1 col-2">
             </div>
             <div class="col-md-11 col-10">
             </div>
             </div>

             <div class="row">
         <div class="col-md-1 col-2">
             </div>
             <div class="col-md-10 col-10">
            
             
  
  <p className="testimonialname fordesktoponly">Adesewa Korede</p>
             </div>
     </div>
 </div>

    
   </div>
    </div>
</div>

)

};


export default Testimonials;